// extracted by mini-css-extract-plugin
module.exports = {"detail":"ReferenceNumberOperationDetails_detail__1Y0n9","link":"ReferenceNumberOperationDetails_link__3NPea","amount":"ReferenceNumberOperationDetails_amount__3ewCg"};